/* global FWP */

import smoothScroll from '@plugins/smooth-scroll';

export default class Search {

  constructor() {
    this.searchContainer = document.getElementById('search-page');

    if (!this.searchContainer) {
      return;
    }

    // Delay for auto-refresh of search, in milliseconds
    this.keywordSearchDelay = 500;
    this.keywordSearchTimeout = null;
    this.resultsHidden = false;

    this.searchTopElement = this.searchContainer.querySelector('#search-page-top');
    this.form = this.searchTopElement.querySelector('#search-page-form');
    this.formTermsElement = this.form.querySelector('#search-page-terms');
    this.selectionsElement = this.searchTopElement.querySelector('.facetwp-selections');
    this.$resultsContainerElement = $('#search-page-results .search-page-results-inner');
    this.sidebar = this.searchContainer.querySelector('#search-page-sidebar');
    this.sidebarToggle = this.sidebar.querySelector('#search-page-sidebar-toggle');

    // On submission of search form with keyword field, refresh FacetWP instead
    // of a full page load/losing facet params
    this.form.addEventListener('submit', (event) => {
      this.onSubmit(event);
    });

    // Auto-submit search when form inputs change
    this.form.addEventListener('change', () => {
      this.onSubmit();
    });

    // Auto-fire change event on a delay when user presses a key in the search
    // input.
    // (Maybe - see onTermsKeyup)
    this.formTermsElement.addEventListener('keyup', () => {
      clearTimeout(this.keywordSearchTimeout);
      this.keywordSearchTimeout = setTimeout(
        () => {
          this.onTermsKeyup();
        },
        this.keywordSearchDelay,
        event
      );
    });

    // Reset search term on reset
    FWP.hooks.addAction('facetwp/reset', () => {
      this.formTermsElement.value = '';
      this.onSubmit();
    });

    // Fix up facet selections markup
    FWP.hooks.addAction('facetwp/loaded', () => {
      this.wrangleSelections();
    }, 100);

    // Toggle hide/unhide of JS-only and noJS-only elements
    $('#search-page-submit-button').attr('hidden', '');
    $('#search-page-reset-button, #search-page-results-count').removeAttr('hidden');

    // Mobile toggle for search filters
    this.sidebarToggle.setAttribute('aria-controls', 'search-page-sidebar-inner');
    this.sidebarToggle.setAttribute('aria-expanded', 'false');
    this.sidebarToggle.addEventListener('click', () => {
      this.onSidebarToggleClick();
    });
    this.sidebarToggle.removeAttribute('hidden');
    this.sidebar.classList.add('-mobile-hidden');

    // FacetWP's AJAX process start and load:
    // Show loading spinner.
    // Fade content out and in.
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!FWP.loaded && !reducedMotionQuery.matches) {
      this.$resultsContainerElement.animate({
        opacity: 'toggle',
        height: 'toggle'
      }, 0);

      this.searchHidden = true;
    }

    $(document).on('facetwp-refresh', () => {
      window.aauwLoading.addEvent('facetwp-refresh', true);

      // Don't toggle again if already hidden, and don't hide on first page load
      if (!this.searchHidden && FWP.loaded) {
        const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!reducedMotionQuery.matches) {
          this.$resultsContainerElement.animate({
            opacity: 'toggle',
            height: 'toggle'
          }, 200);

          this.searchHidden = true;
        }
      }
    });

    $(document).on('facetwp-loaded', () => {
      window.aauwLoading.endEvent('facetwp-refresh');

      if (this.searchHidden) {
        this.$resultsContainerElement.animate({
          opacity: 'toggle',
          height: 'toggle'
        }, 200);

        this.searchHidden = false;
      }
    });

    // Reveal JS-only search facets
    const facets = this.sidebar.querySelectorAll('.search-page-sidebar-facet');
    facets.forEach(function(facet) {
      facet.removeAttribute('hidden');
    });

    // Scroll up to start of search content when facetwp refreshes
    this.firstFacetRefreshDone = false;
    $(document).on('facetwp-refresh', () => {
      if (this.firstFacetRefreshDone) {
        // Scroll up on page change
        smoothScroll(this.searchContainer, false);
      } else {
        // FacetWP will do a refresh on page load, don't scroll for that
        this.firstFacetRefreshDone = true;
      }
    });
  }

  onSidebarToggleClick() {
    this.sidebar.classList.toggle('-mobile-hidden');

    if (this.sidebarToggle.getAttribute('aria-expanded') === 'true') {
      this.sidebarToggle.setAttribute('aria-expanded', 'false');
    } else {
      this.sidebarToggle.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * On form submit, refresh FacetWP instead of doing a page load
   */
  onSubmit(event = null) {
    if (event) {
      event.preventDefault();
    }

    const newUrl = new URL(document.location),
          currentUrlTerms = newUrl.searchParams.get('s'),
          currentInputTerms = this.formTermsElement.value
    ;
    if (currentUrlTerms !== currentInputTerms) {
      newUrl.searchParams.set('s', currentInputTerms);
    }

    const newUrlString = newUrl.toString();
    if (document.location.toString() !== newUrlString) {
      // Set is_popstate so that FWP does not call pushState() again
      /* eslint-disable camelcase */
      const oldPopstate = FWP.is_popstate;
      FWP.is_popstate = true;

      history.pushState(null, null, newUrl.toString());
      FWP.refresh();

      FWP.is_popstate = oldPopstate;
      /* eslint-enable camelcase */
    }
  }

  onTermsKeyup() {
    const newUrl = new URL(document.location),
          currentUrlTerms = newUrl.searchParams.get('s'),
          currentInputTerms = this.formTermsElement.value
    ;
    if (currentUrlTerms !== currentInputTerms) {
      this.onSubmit();
    }
  }

  /**
   * Fix up facet selections markup
   */
  wrangleSelections() {
    const selections = this.selectionsElement.querySelectorAll('.facetwp-selection-value');
    selections.forEach((selection) => {
      const srPrefix = document.createElement('span');
      srPrefix.setAttribute('class', 'sr-text');
      srPrefix.textContent = 'Reset Filter ';
      selection.insertBefore(srPrefix, selection.firstChild);

      selection.setAttribute('role', 'button');
      selection.setAttribute('tabindex', 0);
    });
  }
}
